// Store
import { createSlice } from "@reduxjs/toolkit";
import { customAsyncThunk } from "store/slice/slices.functions";

// Services
import { ClientHubByIdResponse, fetchClientHubByOrgId } from "services";

// Utils
import { isEmpty } from "lodash";

// Types
import { RootState } from "app/store";
import { RequestInfo } from "store/slice/store.types";

type TUserSelectedHubSlice = {
    status: RequestInfo;
    data: ClientHubByIdResponse | undefined;
};

const initialState: TUserSelectedHubSlice = {
    status: "pristine",
    data: {} as ClientHubByIdResponse | undefined,
};

export const fetchUserSelectedHubData = customAsyncThunk<ClientHubByIdResponse | undefined, { orgId: number | string }>(
    "sysadmin/userSelectedHub/fetch",
    async (params, { getState }) => {
        const {
            sysadmin: { userSelectedHub },
        } = getState();

        if (!isEmpty(userSelectedHub.data)) {
            return userSelectedHub.data;
        } else {
            const { orgId } = params;
            const { data: clientHubData } = await fetchClientHubByOrgId(Number(orgId));
            return clientHubData;
        }
    }
);

const userOrganizationsSlice = createSlice({
    name: "sysadmin/userSelectedHub",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchUserSelectedHubData.pending, (state) => ({
            ...state,
            status: "fetching",
        }));
        builder.addCase(fetchUserSelectedHubData.rejected, (state) => ({
            ...state,
            status: "error",
        }));
        builder.addCase(fetchUserSelectedHubData.fulfilled, (state, action) => ({
            data: action.payload,
            status: "done",
        }));
    },
});

export const getUserSelectedHubData = (store: RootState) => store.sysadmin.userSelectedHub;

export default userOrganizationsSlice.reducer;
